import { FC } from 'react'

import { Loading } from '../../components'
import { useTermsStatus, useUser } from '../../hooks'
import { AuthLayout } from '../../pages/AuthLayout'
import { TermsForm } from '../TermsForm'

export const TermsAgreements: FC = ({ children }) => {
  const { uncompliantTerms, isError: termsError, isLoading: termsLoading } = useTermsStatus()
  const { data } = useUser()

  const showTerms =
    (data && !data.user.isEmulated && uncompliantTerms && uncompliantTerms.length > 0) ||
    termsLoading ||
    termsError

  return termsLoading ? (
    <Loading large />
  ) : showTerms ? (
    <AuthLayout variant="content">
      <TermsForm />
    </AuthLayout>
  ) : (
    <>{children}</>
  )
}
